import { FormControlLabel as MuiFormControlLabel, FormControlLabelProps as MuiFormControlLabelProps } from '@mui/material';
import React, { useMemo } from 'react';
import styled from 'styled-components';

export type FormControlLabelProps = {
  /**
   * @deprecated
   * @since 3.0.0 - border removed to match new design references
   */
  withoutBorder?: boolean;
  reversed?: boolean;
  /**
   * @description alt prop for {@link MuiFormControlLabelProps.disabled}
   */
  readOnly?: boolean;
  /**
   * @description The props used for slots inside.
   */
  componentsProps?: {
    typography?: any;
  };
} & Omit<MuiFormControlLabelProps, 'componentsProps' | 'ref'> &
  any;

type LabelPlacementType = FormControlLabelProps['labelPlacement'];
const labelPlacementReverseMap: Record<Exclude<LabelPlacementType, undefined>, LabelPlacementType> = {
  top: 'bottom',
  bottom: 'top',
  end: 'start',
  start: 'end',
};

const MuiFormControlLabelBase = styled(MuiFormControlLabel)``;

const FormControlLabel = React.forwardRef<HTMLLabelElement, FormControlLabelProps>(
  (
    {
      label: labelProp,
      labelPlacement: labelPlacementProp = 'end',
      disableTypography,
      componentsProps,
      reversed,
      width,
      disabled,
      readOnly,
      margin = 0,
      sx,
      ...rest
    },
    ref
  ) => {
    const disabledOrReadonly = disabled || readOnly;
    const label = useMemo(() => {
      if (disableTypography) {
        return labelProp;
      }

      return labelProp;
    }, [componentsProps, disableTypography, labelProp]);

    const labelPlacement: LabelPlacementType = useMemo(() => {
      if (reversed) {
        return labelPlacementReverseMap[labelPlacementProp];
      }

      return labelPlacementProp;
    }, [labelPlacementProp, reversed]);

    return (
      <MuiFormControlLabelBase
        ref={ref}
        disabled={disabledOrReadonly}
        label={label}
        labelPlacement={labelPlacement}
        disableTypography
        sx={{
          width,
          margin,
          gap: '8px',
          ...sx,
        }}
        {...rest}
      />
    );
  }
);

export default FormControlLabel;
